import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadsStatus } from '../../requests/lead_manage_lead_status_request';
import {
    leadManageGetLeadsStatusSuccess,
    leadManageGetLeadsStatusFailure,
} from '../actions/lead_manage_lead_status.actions';
import { LEAD_MANAGE_GET_LEADS_STATUS } from '../constants/lead_manage_leads_status.constants';

function* leadManageGetLeadsStatusRequest() {
    const leadStatus = yield call(getLeadsStatus);
    if (leadStatus.result) {
        yield put(leadManageGetLeadsStatusSuccess(leadStatus.options));
    } else {
        yield put(leadManageGetLeadsStatusFailure(leadStatus.error));
    }
}

export default function* leadManageGetLeadsStatusSaga() {
    yield takeEvery(LEAD_MANAGE_GET_LEADS_STATUS, leadManageGetLeadsStatusRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/lead_manage_get_lead_status.saga.js